var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.62 8.5916C19.57 3.9716 15.54 1.8916 12 1.8916C12 1.8916 12 1.8916 11.99 1.8916C8.45997 1.8916 4.41997 3.9616 3.36997 8.5816C2.19997 13.7416 5.35997 18.1116 8.21997 20.8616C9.27997 21.8816 10.64 22.3916 12 22.3916C13.36 22.3916 14.72 21.8816 15.77 20.8616C18.63 18.1116 21.79 13.7516 20.62 8.5916ZM12 13.6016C10.26 13.6016 8.84997 12.1916 8.84997 10.4516C8.84997 8.7116 10.26 7.3016 12 7.3016C13.74 7.3016 15.15 8.7116 15.15 10.4516C15.15 12.1916 13.74 13.6016 12 13.6016Z",
    fill: "#033A3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.141602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.f8f77a8283628bef78fae61b4e642fed.svg";
export { ForwardRef as ReactComponent };